import React,{Component} from 'react';
import {formatPrice,formatQuantity} from '../helpers/helpers'

class QMainProductView extends Component{
    
    

    render() {  
            var thick = this.props.product.productThickness
                thick = thick.slice(-3)
        return (
                <tr>
                    <td>{this.props.product.productName}</td>
                    <td>{this.props.product.productDimension}</td>
                    <td>0.{thick}</td>
                    <td>{formatQuantity(this.props.product.productNumber)}</td>
                    <td>{this.props.product.productUnit}</td>
                    <td>{formatPrice(this.props.product.productPrice)}</td>
                    <td>{this.props.product.productUnit}</td>
                    <td>{this.props.product.productDiscount}%</td>
                    <td>{formatPrice(this.props.product.productTotal)}</td>
                </tr>
                    
 
        );
    }
}

export default  QMainProductView;


// WEBPACK FOOTER //
// ./src/components/QMainProductView.js